import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import Header from "./components/top_head";
import Navbar from "./components/navbar";
import Down_nav from "./components/down_nav";
import ContentOverlay from "./components/content_overlay";
import ContentOverlay2 from "./components/content_overlay_new";

// Pages
import AbstractPage from "./pages/abstract";
import AnnouncementsPage from "./pages/announcements";
import E_linksPage from "./pages/e-links";
import BooksPage from "./pages/books";
import IntroPage from "./pages/intro";
import ArticlePage from "./pages/article";
import NewsPage from "./pages/news";
import PosterPage from "./pages/posters";
import ReportPage from "./pages/reports";
import BibliographyPage from "./pages/bibliography";
import ForumPage from "./pages/forum";
import WebinarsPage from "./pages/webinar";
import EditorsPage from "./pages/editors";
import ExpertsPage from "./pages/experts";

function App() {
  return (
    <div
      className="body"
      style={{
        backgroundImage: "url(images/kerala_3k_2.jpeg)",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        overflow: "hidden",
      }}
    >
      <Router basename="/biodiversity/sahyadri_enews/newsletter/Issue91">
        <Header />
        <Navbar />

        <Routes>
          <Route path="/" element={<AbstractPage />} />
          <Route path="/intro" element={<IntroPage />} />
          <Route path="/article" element={<ArticlePage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/posters" element={<PosterPage />} />
          <Route path="/report" element={<ReportPage />} />
          <Route path="/bibliography" element={<BibliographyPage />} />
          <Route path="/experts" element={<ExpertsPage />} />
          <Route path="/forum" element={<ForumPage />} />
          <Route path="/webinar" element={<WebinarsPage />} />
          <Route path="/editors" element={<EditorsPage />} />
          <Route path="/announcements" element={<AnnouncementsPage />} />
          <Route path="/books" element={<BooksPage />} />
          <Route path="/e-links" element={<E_linksPage />} />
        </Routes>

        <Down_nav />
      </Router>
    </div>
  );
}

export default App;
